import * as React from "react";
import {ExceptionType} from "@bizform/type/model/model/Exception.model";
import {DomAttribute} from "@bizform/type/model/dom/DomAttribute.model";
import {DomHelper} from "@bizform/helper/dist/js/bizflow/helper.min";
import {
    ExceptionHandler,
    FormStateService,
    GridActionService,
    ProxyBaseClass
} from "@bizform/core/dist/js/bizflow/core.min";


@ProxyBaseClass("root")
class ContextHelperUtil {
    destroyed: boolean;
    private _orgTarget: HTMLElement;

    destruction() {
    }

    onAction(target: HTMLElement, e: any, mode: string, applicationId: string, formId: string, columns: any, index: number, context: any, contextList: any, state: any, contextContainer: any, overlay: any, props: any) {
        const info = columns[index];
        if (mode === "context") {
            const rContext = (info.contextScope === "global") ? state.context : info.context;
            if (rContext && rContext.length) {
                const menu = [];
                this._makeOrgTarget(e.target);
                if (!contextList["_" + index]) {
                    for (const k in rContext) {
                        const label = rContext[k].label ? rContext[k].label.trim() : null;
                        const confirm = rContext[k].confirm ? rContext[k].confirm.trim() : null;
                        if (label && rContext[k].action) {
                            menu.push({
                                label: label,
                                action: rContext[k].action,
                                icon: rContext[k].icon,
                                confirm: confirm,
                                state: rContext[k].state,
                                reload: rContext[k].reload
                            });
                        }
                    }
                }
                this._contextHide(context, contextContainer);
                this._contextMenu(menu, "_" + index, target, e, applicationId, formId, context, contextList, contextContainer, overlay, props);
            }
        } else if (mode === "click") {
            const rState: string = (info.clickScope === "global") ? state.state : info.state;
            if (rState) {
                FormStateService.mergeState(applicationId, formId, null, JSON.parse(rState), target);
            }
            const context = (info.clickScope === "global") ? state.click : info.click;
            overlay();
            GridActionService.callAction(applicationId, formId, context, e.target, props);
        }
    }

    onInlineAction(target: HTMLElement, e: any, applicationId: string, formId: string, context: any, contextList: any, inlineContext: any, contextContainer: any, overlay: any, props: any) {
        if (context) {
            const menu = [];
            this._makeOrgTarget(e.target);
            if (!contextList["__"]) {
                const type = ["update", "reset", "cancel"];
                const action = ["Update", "Reset", "Cancel"];
                for (const k in type) {
                    const info = {
                        label: inlineContext[type[k]] ? inlineContext[type[k]].trim() : "",
                        action: "Run" + action[k],
                        state: inlineContext[type[k] + "State"],
                        icon: inlineContext[type[k] + "Icon"]
                    };
                    if (info.label) {
                        menu.push(info);
                    }
                }
            }
            this._contextMenu(menu, "__", target, e, applicationId, formId, context, contextList, contextContainer, overlay, props);
        }
    }

    private _makeOrgTarget(target: HTMLElement) {
        while (!target.hasAttribute(DomAttribute.GRIDPK)) {
            target = target.parentElement;
        }
        this._orgTarget = target.firstChild as HTMLElement;
    }

    private _contextMenu(menu: Array<any>, type: string, target: HTMLElement, e: any, applicationId: string, formId: string, context: any, contextList: any, contextContainer: any, overlay: any, props: any) {
        this._contextHide(context, contextContainer);
        if (!contextList[type]) {
            contextList[type] = [];
            const className = menu.length === 1 ? "" : " text-left";
            for (const k in menu) {
                const icon = menu[k].icon && menu[k].icon.length ? "<i class='" + menu[k].icon.join(" ") + " d-inline-block text-center' style='width: 20px; '></i>" : "";
                const button = document.createElement("button");
                button.setAttribute("class", "d-block w-100 p-button p-component p-button-secondary p-button-text-only mb-1 pt-0 pr-1 pb-0 pl-1 " + className);
                button.setAttribute("bf-data-value", (menu[k].confirm ? btoa(encodeURIComponent(menu[k].confirm)) : "") + "!" + (menu[k].state ? btoa(encodeURIComponent(menu[k].state)) : "") + "!" + btoa(encodeURIComponent(menu[k].action)));
                if (menu[k].reload) {
                    button.setAttribute(DomAttribute.GRIDBUTTON, "reload");
                }
                button.style.height = "1.5rem";
                button.style.lineHeight = "1.3rem";
                button.onclick = (event: MouseEvent) => {
                    this._onContextClick(this._orgTarget, event, applicationId, formId, overlay, props);
                };
                button.innerHTML = `${icon}${menu[k].label}`;
                contextList[type].push(button);
                contextContainer.appendChild(button);
            }
            this._contextGrid(target, e, context, contextContainer);
            e.preventDefault();
        } else if (contextList[type].length) {
            for (const k in contextList[type]) {
                contextContainer.appendChild(contextList[type][k]);
            }
            this._contextGrid(target, e, context, contextContainer);
            e.preventDefault();
        }
    }

    private _contextGrid(target: HTMLElement, e: any, context: any, contextContainer: any) {
        const grid = DomHelper.getGridInformationFromDom(target, null);
        contextContainer.setAttribute(DomAttribute.GRIDPK, grid.containerPk);
        context.toggle(e);
    }

    private _contextHide(context: any, contextContainer: any) {
        if (context) {
            const buttons: Array<HTMLElement> = Array.from(contextContainer.querySelectorAll("button"));
            if (buttons && buttons.length) {
                for (const k in buttons) {
                    buttons[k].parentElement.removeChild(buttons[k]);
                }
            }
            context.hide(null);
        }
    }

    private _onContextClick(orgTarget: any, e: any, applicationId: string, formId: string, overlay: any, props: any) {
        overlay();
        let target = e.target;
        while (!target.hasAttribute("bf-data-value")) {
            target = target.parentElement;
        }
        let [confirm, state, action] = target.getAttribute("bf-data-value").split("!");
        confirm = confirm ? decodeURIComponent(atob(confirm)) : "";
        state = state ? decodeURIComponent(atob(state)) : null;
        action = action ? decodeURIComponent(atob(action)) : null;
        let func = (result) => {
            if (result) {
                if (state && state.trim().startsWith("{")) {
                    FormStateService.mergeState(applicationId, formId, null, JSON.parse(state), target);
                }
                GridActionService.callAction(applicationId, formId, action, orgTarget, props);
            }
            (func as any).__proto__ = null;
            func = null;
        };
        if (confirm) {
            ExceptionHandler.confirm(ExceptionType.INFO, confirm, func);
        } else {
            func(true);
        }
    }
}

export const ContextHelper: ContextHelperUtil = new ContextHelperUtil();
